// Single source of truth for the runtime VERSION string.
// Keep in sync with package.json and jsr.json on release
// (the `release` script checks this).
export const VERSION = "3.0.0";
